import { render, staticRenderFns } from "./chooseShopVipUser.vue?vue&type=template&id=3880f13e&scoped=true"
import script from "./chooseShopVipUser.vue?vue&type=script&lang=js"
export * from "./chooseShopVipUser.vue?vue&type=script&lang=js"
import style0 from "./chooseShopVipUser.vue?vue&type=style&index=0&id=3880f13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880f13e",
  null
  
)

export default component.exports